import React, { Suspense } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Firebase, { FirebaseContext } from "./components/Firebase";
import Logo from "./assets/Asset 1.png";
import CircularProgress from "@material-ui/core/CircularProgress";
/*
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import NewHome from "./pages/NewHome";
import Privacy from "./pages/PrivacyPolicy";
import Register from "./pages/Register";
import RegistrationSuccess from "./pages/RegistrationSuccess";
import ErrorPage from "./pages/404page";
import About from "./pages/About";
*/

const Home = React.lazy(() => import("./pages/NewHome"));
const Dashboard = React.lazy(() => import("./pages/Dashboard"));
const Test = React.lazy(() => import("./pages/Home"));
const Privacy = React.lazy(() => import("./pages/PrivacyPolicy"));
const Register = React.lazy(() => import("./pages/Register"));
const RegistrationSuccess = React.lazy(() =>
  import("./pages/RegistrationSuccess")
);
const ErrorPage = React.lazy(() => import("./pages/404page"));
const About = React.lazy(() => import("./pages/About"));
const Login = React.lazy(() => import("./components/login"));
const AiDash = React.lazy(() => import("./components/aidash"));
const RegisteredUsers = React.lazy(() =>
  import("./components/registeredusers")
);
const TestUsers = React.lazy(() => import("./components/testResults"));


function App() {
  return (
    <FirebaseContext.Provider value={new Firebase()}>
      <Suspense
        fallback={
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20%",
            }}
          >
            <CircularProgress style={{ color: "black" }} />
            <img
              src={Logo}
              alt="logo"
              style={{ width: 100, height: 28, paddingTop: "1em" }}
            />
          </div>
        }
      >
        <Router>
          <Switch>
            <Route path="/" exact>
              <Home />
            </Route>

            <Route path="/test">
              <Test />
            </Route>

            <Route path="/privacypolicy">
              <Privacy />
            </Route>

            <Route path="/register/:id" component={Register} />

            <Route
              path="/registrationsuccess"
              component={RegistrationSuccess}
            />

            <Route path="/dashboard">
              <Dashboard />
            </Route>

            <Route path="/about">
              <About />
            </Route>

            <Route path="/aihiddenbackdoor">
              <Login />
            </Route>

            <Route path="/aibackdoor/aidash">
              <AiDash />
            </Route>

            <Route path="/aibackdoor/registeredusers">
              <RegisteredUsers />
            </Route>

            <Route path="/aibackdoor/testResults">
              <TestUsers />
            </Route>

         


            <Route component={ErrorPage} />
          </Switch>
        </Router>
      </Suspense>
    </FirebaseContext.Provider>
  );
}

export default App;
